// API Configuration
// Uses config.js if available (for deployed sites), otherwise uses env variable.
// Ignores the placeholder URL so dev/preview falls back to REACT_APP_BACKEND_URL.

const PLACEHOLDER_URLS = [
  'https://api.yourdomain.com',
  'http://api.yourdomain.com',
  'https://your-api-url.com',
  ''
];

export const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const cfg = window.LINKLITE_CONFIG?.API_URL;
    if (cfg && !PLACEHOLDER_URLS.includes(cfg)) {
      return cfg;
    }
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Computed at runtime each time it's accessed
export const API = (() => {
  const base = getApiUrl();
  return `${base}/api`;
})();
